import { css } from '@microsoft/fast-element';
import { commonLoginRouteStyles } from '../../styles';
export const LoginFormStyles = css `
  ${commonLoginRouteStyles}
  .link-url {
    width: fit-content;
    cursor: pointer;
    font-weight: 500;
    font-size: 12px;
    color: var(--accent-foreground-rest);
    opacity: 80%;
    padding: 1px 0;
    line-height: calc(var(--design-unit) * 6px);
    text-decoration: none;
  }

  .link-url:hover {
    color: var(--accent-foreground-hover);
    opacity: 100%;
    border-bottom: 1px solid;
    margin-bottom: -1px;
  }

  .action-btn {
    margin: calc(var(--design-unit) * 5px) 0;
  }

  .sso {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
  }

  .sso .form-title {
    font-size: var(--type-ramp-base-font-size);
    margin-bottom: calc(var(--design-unit) * 2px);
  }

  .links {
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .password-links {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-self: flex-start;
  }

  .account-links {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-self: flex-start;
  }

  .case-warning {
    color: #379ec0;
    font-size: 0.83em;
    margin-block-start: 1em;
    margin-block-end: 1em;
  }

  .version {
    width: fit-content;
    font-weight: 500;
    font-size: 10px;
    color: var(--accent-foreground-rest);
    opacity: 80%;
    padding: 1px 0;
    line-height: calc(var(--design-unit) * 6px);
  }
`;
